import React, { useEffect, useState, } from 'react'
import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import { coinModelGet, } from '../../models/coins/coin';
import {
    responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, buttonProcessGet, processEvaluateGet, languageObjGet, isUndNullEmp, awaitDelay,
} from '../../helpers/settings'
import axios from 'axios';
import { countryModelGet } from '../../models/countries/country';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'CoinsAddEditDetails';

const { app, collections: dbColle, icons, images, labels, messages, } = globalSettings;
const { backend } = app;
const { html: reactHtml, } = globalSettings?.react;
const { properties: dbProps, } = dbColle;

export default function CoinsAddEditDetails({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    coin = coinModelGet({}),
    setCoin = () => { },
    countries = [countryModelGet({})],
    dtId = '',
    dtObj = {},
    dtRowIndex = 0,
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const [descriptionError, setDescriptionError] = useState('');
    const [codeAError, setCodeAError] = useState('');
    const [codeNError, setCodeNError] = useState('');
    const [countryIdError, setCountryIdError] = useState('')
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnCoinModalSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnCoinModalBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnCoinModalClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // inactive: {
            //     id: 'chkCoinModalEnable',
            //     className: 'icheck-primary d-inline',
            // },
            // inactiveReadOnly: {
            //     id: 'chkCoinModalReadOnly',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            // collectionCashes: {
            //     buttons: {
            //         add: {
            //             className: 'btn btn-outline-success float-right btn-sm',
            //             id: 'btndtCountryesIdAdd',
            //         },
            //         delete: {
            //             className: 'btn btn-outline-danger float-right btn-sm mx-1',
            //             id: 'btndtCountryesIdDelete',
            //         },
            //     },
            //     icons: {
            //         add: {
            //             id: 'icondtCountryesIdAdd',
            //             className: icons?.plusCircle,
            //         },
            //         delete: {
            //             id: 'icondtCountryesIdDelete',
            //             className: icons?.trash,
            //         },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtCountryesId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtCountryesId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         add: {
            //             id: 'spdtCountryesIdAdd',
            //             className: '',
            //         },
            //         delete: {
            //             id: 'spdtCountryesIdDelete',
            //             className: '',
            //         },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoCoinModalSave',
                className: icons?.save,
            },
            back: {
                id: 'icoCoinModalBack',
                className: icons?.arrowCircleLeft,
            },
            close: {
                id: 'icoCoinModalClose',
                className: icons?.plusCircle,
            },
        },
        inputs: {
            description: {
                id: 'inputCoinModalDescription',
                className: 'form-control',
            },
            codeA: {
                id: 'inputCoinModalCodeA',
                className: 'form-control',
            },
            codeN: {
                id: 'inputCoinModalCodeN',
                className: 'form-control',
            },
        },
        selects: {
            countries: {
                id: 'selCoinModalCountries',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spCoinModalSave',
                className: '',
            },
            back: {
                id: 'spCoinModalBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region coins (methods)
    const coinAddPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'coinAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRow = [];
            //#endregion variables

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            };

            response = validateFormDataAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            };
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create data (coin)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                coin: coin,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoins}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            coin = response?.result || {};
            //#endregion create data (coin)

            //#region datatadle data set
            //#region processButtons set
            dataObj = {
                processButtons: [
                    {
                        isVisible: true,
                        showDivider: true,
                        isEnabled: true,
                        methodName: backend?.methods?.showRates,
                        icon: icons?.chartLine,
                        label:
                            labels?.rates?.[languageObj?.id],
                    },
                    {
                        isVisible: true,
                        showDivider: false,
                        isEnabled: processEvaluateGet({
                            object: coin,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.delete?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result,
                        methodName: backend?.methods?.delete,
                        icon: icons?.trash,
                        label: labels?.delete?.[languageObj?.id],
                    },
                ],
            };
            //#endregion processButtons set

            dtRow.push(
                coin.description,
                coin.codeA,
                coin.codeN,
                buttonProcessGet({
                    id: coin.id,
                    description: coin.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: processEvaluateGet({
                        object: coin,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.coin.en.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: processEvaluateGet({
                        object: coin,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result,
                    showDelete: false,
                    labelDelete: '',
                    enabledDelete: false,
                    processButtons: dataObj?.processButtons,
                    subMethod: currentMethod,
                })?.result
            );

            $(`#${dtId}`)?.DataTable()?.row?.add(dtRow)?.draw(true);
            //#endregion datatadle data set

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const coinEditPostAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'coinEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRow = [];
            //#endregion variables

            //#region initialize
            response = errorsDefaultSet({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            };

            response = validateFormDataAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            };
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region coin update
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                coin: coin,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCoins}/${coin.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            coin = response?.result || {};
            //#endregion update data (coin)

            //#region datatadle data set
            //#region processButtons set
            dataObj = {
                processButtons: [
                    {
                        isVisible: true,
                        showDivider: true,
                        isEnabled: true,
                        methodName: backend?.methods?.showRates,
                        icon: icons?.chartLine,
                        label:
                            labels?.rates?.[languageObj?.id],
                    },
                    {
                        isVisible: true,
                        showDivider: false,
                        isEnabled: processEvaluateGet({
                            object: coin,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.delete?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result,
                        methodName: backend?.methods?.delete,
                        icon: icons?.trash,
                        label: labels?.delete?.[languageObj?.id],
                    },
                ],
            };
            //#endregion processButtons set

            dtRow.push(
                coin.description,
                coin.codeA,
                coin.codeN,
                buttonProcessGet({
                    id: coin.id,
                    description: coin.description,
                    showDetails: true,
                    labelDetails: labels?.detail?.[languageObj?.id],
                    enabledDetails: processEvaluateGet({
                        object: coin,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.coin.en.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result,
                    showEdit: true,
                    labelEdit: labels?.edit?.[languageObj?.id],
                    enabledEdit: processEvaluateGet({
                        object: coin,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result,
                    showDelete: false,
                    labelDelete: '',
                    enabledDelete: false,
                    processButtons: dataObj?.processButtons,
                    subMethod: currentMethod,
                })?.result
            );

            $(`#${dtId}`)?.DataTable()?.row(dtRowIndex).data(dtRow)?.draw(true);
            //#endregion datatadle data set

            await defaultValueSetAsync({
                isModalClose: true,
                subMethod: currentMethod,
            });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion coins (metods)

    //#region methods (others)
    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSet = ({
        property = '',
        value = '',
        subMethod = '',
    }) => {
        const currentMethod = 'formDataSet';
        let response = responseGet();
        try {
            setCoin({
                ...coin,
                [property]: value,
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
    }

    const validateFormDataAsync = ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region methods
            if (isUndNullEmp({ data: coin?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: coin?.codeA, subMethod: currentMethod, })?.result) {
                setCodeAError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (coin.codeA.length !== 3) {
                setCodeAError(`${messages?.thisFieldRequired?.[languageObj?.id]}. 3 ${labels?.characters?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: coin?.codeN, subMethod: currentMethod, })?.result) {
                setCodeNError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            } else if (coin.codeN.length !== 3) {
                setCodeNError(`${messages?.thisFieldRequired?.[languageObj?.id]}. 3 ${labels?.characters?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: coin?.countryId, subMethod: currentMethod, })?.result) {
                setCountryIdError(`${messages?.youMustSelectCountry?.[languageObj?.id]}`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const errorsDefaultSet = ({
        subMethod = '',
    }) => {
        const currentMethod = 'errorsDefaultSet';
        let response = responseGet();
        try {
            setCodeAError('');
            setCodeNError('');
            setCountryIdError('');
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactHtml?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactHtml?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr({ readOnly: processType !== 0, });
            //$(`#${controls?.checkBox?.inactive?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.inputs?.codeA?.id}`)?.attr({ readOnly: processType !== 0, });
            $(`#${controls?.inputs?.codeN?.id}`)?.attr({ disabled: processType !== 0, });
            $(`#${controls?.selects?.countries?.id}`)?.attr({ disabled: processType !== 0, });
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactHtml?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
    }, [auth])
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt='coins'
                        src={images?.coinsLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.coin?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ?
                coinAddPostAsync({ e: e, subMethod: 'form - onSubmit' }) :
                coinEditPostAsync({ e: e, subMethod: 'form - onSubmit' })}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => processType === 0 ? coinAddPostAsync(e) : coinEditPostAsync(e)}> */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt='coins' src={images?.coinsLogo} style={styles?.cardHeaderLogo}></img> - {labels?.coin?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* <div className='card-body'> */}
                    {processType === 2 ?
                        <div className='text-muted'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {labels?.coin?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{coin?.description || ''}</b>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {`${labels?.codeA?.[languageObj?.id]}`}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{coin?.codeA || ''}</b>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {`${labels?.codeN?.[languageObj?.id]}`}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{coin?.codeN || ''}</b>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    {`${labels?.country?.[languageObj?.id]}`}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        countries?.find(({ id }) => id === coin?.countryId)?.description || ''
                                    }</b>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.description?.id}
                                        className={controls?.inputs?.description?.className}
                                        //autoFocus
                                        placeholder={labels?.name?.[languageObj?.id]}
                                        onChange={(e) => formDataSet({
                                            property: dbProps?.description,
                                            value: e?.target?.value,
                                            subMethod: 'input - description',
                                        })}
                                        onFocus={() => setDescriptionError('')}
                                        value={coin?.description || ''}
                                        tooltip='tooltip'
                                        title={labels?.name?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={globalSettings?.icons?.spellCheck} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.codeA?.id}
                                                className={controls?.inputs?.codeA?.className}
                                                placeholder={labels?.codeA?.[languageObj?.id]}
                                                onChange={(e) => formDataSet({
                                                    property: dbProps?.codeA,
                                                    value: e?.target?.value,
                                                    subMethod: 'input - codeA',
                                                })}
                                                onFocus={() => setCodeAError('')}
                                                value={coin?.codeA || ''}
                                                tooltip='tooltip'
                                                title={labels?.codeA?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(codeAError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.codeN?.id}
                                                className={controls?.inputs?.codeN?.className}
                                                placeholder={labels?.codeN?.[languageObj?.id]}
                                                onChange={(e) => formDataSet({
                                                    property: dbProps?.codeN,
                                                    value: e?.target?.value,
                                                    subMethod: 'input - codeN',
                                                })}
                                                onFocus={() => setCodeNError('')}
                                                value={coin?.codeN || ''}
                                                tooltip='tooltip'
                                                title={labels?.codeN?.[languageObj?.id]} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(codeNError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <select id={controls?.selects?.countries?.id}
                                        className={controls?.selects?.countries?.className}
                                        defaultValue={coin?.countryId || ''}
                                        onChange={(e) => formDataSet({
                                            property: dbProps?.countryId,
                                            value: e?.target?.value,
                                            subMethod: 'sel - countries',
                                        })}
                                        onFocus={() => setCountryIdError('')}>
                                        <option key='nothing' value=''>{labels?.selectCountry?.[languageObj?.id]}</option>
                                        {
                                            countries?.map((detail) => <option key={detail?.id} value={detail?.id}>{detail?.description}</option>)
                                        }
                                    </select>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className='fas fa-globe-americas' />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(countryIdError)}</div>
                            </div>
                        </div>
                    }
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1'
                                    hidden={processType === 2}
                                    tooltip='tooltip'
                                    title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={globalSettings?.icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success'
                                    tooltip='tooltip' title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={globalSettings?.icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>

                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}